import { useState } from "react";
import { Form } from "antd";
import TableModal from "./table-modal";
import CreateReceiverModal from "./create-receiver-modal";
import UpdateReceiverModal from "./update-receiver-modal";
import UploadModal from "./upload-modal";

const ReceiverInfoModal = ({ onClose, fieldName, form, isReturned }) => {
  const [receiverForm] = Form.useForm();
  const [step, setStep] = useState("TABLE");
  const [spin, setSpin] = useState(false);
  const [updateValues, setUpdateValues] = useState(null);

  return (
    <>
      {step === "TABLE" && (
        <TableModal
          onClose={onClose}
          fieldName={fieldName}
          form={form}
          setStep={setStep}
          setUpdateValues={setUpdateValues}
          isReturned={isReturned}
        />
      )}
      {step === "FORM" && (
        <CreateReceiverModal
          form={receiverForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
        />
      )}
      {step === "UPDATE" && (
        <UpdateReceiverModal
          form={receiverForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
          updateValues={updateValues}
        />
      )}
      {step === "UPLOAD" && (
        <UploadModal
          form={receiverForm}
          onClose={onClose}
          setStep={setStep}
          setSpin={setSpin}
          spin={spin}
        />
      )}
    </>
  );
};
export default ReceiverInfoModal;
